import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { Row, Col, Tabs, Tab } from 'react-bootstrap';

import CoverageSelector from './CoverageSelector'
import AdditionalCoverageSelector from './AdditionalCoverageSelector'
import OptionalCoverageSelector from './OptionalCoverageSelector'
import AdditionalInsuredSelector from './AdditionalInsuredSelector'
import featureFlags from '../../utils/featureFlags'
import ExcessQuote from './ExcessQuote'
import TotalPremium from './TotalPremium'
import GCLimits from './GCLimits'
import MinimumPremium from './MinimumPremium'
import NetQuote from './NetQuote';
import { dict } from '../constants';
import BaseRateCheck from './BaseRateCheck';
import DeductibleContainer from './DeductibleContainer';
import ListContainer from './ListContainer';
import DebitNotes from '../../components/shared/DebitNotes'
import { GCList } from './GCList';
import { DesignatedGeneralContractor } from './DesignatedGeneralContractor';
import GCLimitNotes from '../../components/shared/GCLimitNotes';

const { accordion } = dict;

// Added HNOA Coverage for SREQ0248466
const accordionArrayAdditionalCoverage = [
  accordion.tria,
  accordion.hnoa,
  accordion.additionalPollution,
  accordion.additionalSubsidence,
  accordion.additionalExtendedCompletedOps,
  accordion.additionalBanksMortgagees,	
  accordion.additionalInsuredAddition
];
const accordionArrayOptionalCoverage = [accordion.isPCOpsExcluded, accordion.isESWorkExcluded];
let accordionArrayCoverage = [accordion.deductibleWarranty, accordion.standard, accordion.conditional, accordion.biExcluded];
let DEFAULT_COVERAGE_OPTIONS = [
    {
      label: 'Deductible Warranty',
      value: 'deductibleWarranty',
      key: 'deductibleWarranty',
      text: '',
      selected: false,
      onCondition: true,
      condition: 'otherSubcontractorsPaid',
      validationFlag: 'false',
      hideElement: ''
    },
    {
        label: 'Standard',
        value: 'standard',
        key: 'standard',
        text: '',
        selected: false
    },
    {
        label: 'Conditional',
        value: 'conditional',
        key: 'conditional',
        text: '',
        selected: false
    },
    {
        label: 'Bodily Injury Excluded',
        value: 'biExcluded',
        key: 'biExcluded',
        text: '',
        selected: false
    }
];
const COVERAGE_EXCLUSION_OPTIONS = [
    {
      label: 'Product Completed Operations',
      key: 'isPCOpsExcluded',
      value: 'isPCOpsExcluded',
      text: false,
      selected: true,
      disable: false
    },
    {
      label: 'Structural/Exterior Work',
      key: 'isESWorkExcluded',
      value: 'isESWorkExcluded',
      text: false,
      selected: true,
      disable: false,
      hideElement: ''
    }
];
export const DEFAULT_ADDITIONAL_COVERAGE_OPTIONS = [
  {
    label: 'TRIA',
    key: ['terror', 'terrorPremium'],
    value: 'terror',
    text: '',
    disable: false,
    selected: true
  },
  // Added HNOA Coverage for SREQ0248466 - Start
  {
    label: 'HNOA',
    key: 'hnoaPremium',
    value: 'hnoaPremium',
    text: '',
    disable: false,
    selected: false
  },
  // Added HNOA Coverage for SREQ0248466 - End
  {
    label: 'Pollution Exclusion with a Hostile Fire Give Back',
    key: 'pollutionPremium',
    value: 'pollution',
    text: '',
    selected: false,
    disable: false
  },
  {
    label: 'Subsidence Exclusion Removal',
    key: 'subsidencePremium',
    value: 'subsidence',
    text: '',
    selected: false,
    disable: false
  },
  {
    label: 'Extended Product Completed Operations',
    key: 'extendedCompletedOpsPremium',
    value: 'extendedCompletedOps',
    text: '',
    selected: false,
    disable: false
  }, 
  {	
    label: 'Lender/ Mortgagees',	
    key: 'bankPremium',	
    value: 'bankPremium',	
    text: '',	
    disable: false,	
    selected: false,	
    hideElement: ''	
  },	
  {	
    label: 'Additional Insured',	
    key: 'additionalInsureds',	
    value: 'additionalInsureds',	
    text: '',	
    selected: false,	
    disable: false
  }
];

const OIPricing = ({
    additionalCoverage,
    optionalCoverage,
    adjustedCommission,
    basePremium,
    changePricingValue,
    coverage,
    defaultCoverageOptions,
    defaultAdditionalCoverageOptions,
    defaultCoverageExclusionOptions,
    handleAdditionalCoverageChange,
    handleAdditionalInsuredChange,
    handleOptionalCoverageChange,
    handleIncludedCoverageChange,
    handleCoverageChange,
    handleExcessCheck,
    handleNetQuote,
    isModified,
    isUnderwriter,
    manuallySetPricing,
    onBlurHandler,
    options,
    pricingValues,
    rating,
    submission,
    totalPremium,
    updateAdditionalInsuredList,
    updatePricingOptions,
    onCreditNotes,
    onGCLimitNotes,
    excessLimitAmount
}) => {
  const defaultAdditionalCoverageOptionsHide = defaultAdditionalCoverageOptions.map(option => {
    if ( rating && ((option.key === 'bankPremium' && (submission.numberOfBankForms<1 || !submission.numberOfBankForms)) || (option.key === 'additionalInsureds' && (submission.numberOfBankAIForms<1 && submission.numberOfAIForms<1
      || (!submission.numberOfBankAIForms && !submission.numberOfAIForms)))) && submission.type === 'oi' && !rating['oi'][option.key]) {
      option['hideElement'] = 'hideElement';
    } else if (option.hideElement) {
      delete option.hideElement; 
    }
    return option;
  })
  const defaultCoverageOptionsHide = defaultCoverageOptions.map(option => {
    const optionCopy = {...option};
    if (option.onCondition) {
     if (submission[option.condition] && submission[option.condition] !== option.validationFlag) {             
       optionCopy['hideElement'] = 'hideElement';
      return optionCopy;
     } else if (submission[option.condition] && submission[option.condition] === option.validationFlag) {
      optionCopy['hideElement'] = '';
      return optionCopy
     }
    }
    return optionCopy;
  })
  const defaultCoverageExclusionOptionsHide = defaultCoverageExclusionOptions.map(option => {
    const optionCopy = {...option};
    if (optionCopy.key==="isESWorkExcluded" && ((submission.totalCost<=1000000 && submission.projectAddress.projectState!="New York") || (submission.totalCost>1000000 && submission.projectAddress.projectState==="New York"))) {
      optionCopy['hideElement'] = 'hideElement';
    } else if (optionCopy.hideElement) {
      delete optionCopy.hideElement; 
    }
    return optionCopy;
  })
  let validateCreatedDate = moment(moment(submission.dateOfCreation).format('YYYY-MM-DD')).isAfter('2020-05-02');
  let validateEffDate = moment(moment(submission.anticipatedStartDate).format('YYYY-MM-DD')).isAfter('2020-05-02');
  if(!!validateEffDate && !!validateCreatedDate){
    accordion.tria.subHeader = !!accordion.tria[submission.projectAddress.projectState] ? accordion.tria[submission.projectAddress.projectState] : accordion.tria.otherStates
  } 
  else{
    accordion.tria.subHeader = accordion.tria.default;
  }
  accordion.isPCOpsExcluded.subHeader=submission.projectAddress.projectState!="New York"? accordion.isPCOpsExcluded.default: accordion.isPCOpsExcluded.newyork; 
  let optionslCoverage = submission.coverages.gl;
  let isPCOpsExcluded = !!optionslCoverage.optional && optionslCoverage.optional.isPCOpsExcluded ? optionslCoverage.optional.isPCOpsExcluded.selected : submission.isPCOpsChecked; 
  let isESWorkExcluded = !!optionslCoverage.optional && optionslCoverage.optional.isESWorkExcluded ? optionslCoverage.optional.isESWorkExcluded.selected : submission.isESWorkChecked; 
  const subjectivities = submission && submission.ratings && submission.ratings[submission.type] && submission.ratings[submission.type].subjectivities;
  const subjectivitiesTBD = submission && submission.ratings && submission.ratings[submission.type] && submission.ratings[submission.type].subjectivitiesDescription;
  
  const u650Exclusions = submission && submission.ratings && submission.ratings[submission.type] && submission.ratings[submission.type].u650Exclusions;
  
  const PricingTab = (
    <div>
      <NetQuote handleNetQuote={handleNetQuote} adjustedCommission={adjustedCommission} baseCommission={submission.commission} />
            <Row>
                <Col xs={8} md={6}>
                  <CoverageSelector
                        value={coverage}
                        basePremium={pricingValues.basePremium}
                        defaultCoverageOptions={defaultCoverageOptionsHide}
                        accordionArray={accordionArrayCoverage}
                        extraOptions={options}
                        onChange={handleCoverageChange}
                        manuallySetPricing={manuallySetPricing}
                        pricingValues={pricingValues}
                        onBlurHandler={onBlurHandler}
                        updatePricingOptions={updatePricingOptions}
                        changePricingValue={changePricingValue}
                        isModified={isModified}
                        submission={submission}
                        rating={rating}
                    />
                    {(manuallySetPricing && isUnderwriter) && <BaseRateCheck submission={submission}/> }
                    {(manuallySetPricing && isUnderwriter) && <DebitNotes onCreditNotes={onCreditNotes} submission={submission}/>}
                    <OptionalCoverageSelector
                       accordionArray={accordionArrayOptionalCoverage}
                       defaultCoverageExclusionOptions={defaultCoverageExclusionOptionsHide}
                       defaultAdditionalCoverageOptions={defaultAdditionalCoverageOptionsHide}
                       onChange={handleOptionalCoverageChange}
                       pricingValues={pricingValues}
                       extraOptions={options}
                       isModified={isModified}
                       manuallySetPricing={manuallySetPricing}
                       changePricingValue={changePricingValue}
                       type='oi'
                       updatePricingOptions={updatePricingOptions}
                       onBlurHandler={onBlurHandler}
                       submission={submission}
                       value={optionalCoverage}
                       isPCOpsChecked={isPCOpsExcluded}
                       isESWorkChecked={isESWorkExcluded}
                       isUnderwriter={isUnderwriter}
                    />
                    <AdditionalCoverageSelector
                        accordionArray={accordionArrayAdditionalCoverage}
                        changePricingValue={changePricingValue}
                        defaultAdditionalCoverageOptions={defaultAdditionalCoverageOptionsHide}
                        extraOptions={options}
                        isModified={isModified}
                        manuallySetPricing={manuallySetPricing}
                        isUnderwriter={isUnderwriter}
                        onBlurHandler={onBlurHandler}
                        onChange={handleAdditionalCoverageChange}
                        pricingValues={pricingValues}
                        type='oi'
                        updatePricingOptions={updatePricingOptions}
                        value={additionalCoverage}
                        isPCOpsChecked={isPCOpsExcluded}
                        isESWorkChecked={isESWorkExcluded}
                        submission={submission}
                        handleIncludedCoverageChange={handleIncludedCoverageChange}
                   />
                   {(manuallySetPricing && isUnderwriter && submission.additionalInsured === "true") && <AdditionalInsuredSelector	
                      isUnderwriter={isUnderwriter}	
                      onBlurHandler={onBlurHandler}	
                      onChange={handleAdditionalInsuredChange}	
                      type='oi'	
                      updateAdditionalInsuredList={updateAdditionalInsuredList}	
                      submission={submission}	
                   />}
                </Col>
            </Row>


            <TotalPremium id="totalPremium" isModified={isModified} selectedBaseCoverage={optionslCoverage.base} surcharge={pricingValues.surcharge} totalPremium={pricingValues.totalPremium} manuallySetPricing={manuallySetPricing} onBlurHandler={onBlurHandler}/>

            <ExcessQuote
                isModified={isModified}
                submission={submission}
                rating={rating}
                handleExcessCheck={handleExcessCheck}
                manuallySetPricing={manuallySetPricing}
                onBlurHandler={onBlurHandler}
                updatePricingOptions={updatePricingOptions}
                pricingValues={pricingValues}
                isUnderwriter={isUnderwriter}
            />

            {(manuallySetPricing && isUnderwriter) && <GCLimits
                isModified={isModified}
                limits={pricingValues.limits}
                onBlurHandler={onBlurHandler}
                manuallySetPricing={manuallySetPricing}
                type={submission.type}
            />}
            {(manuallySetPricing && isUnderwriter) && <GCLimitNotes onGCLimitNotes={onGCLimitNotes} submission={submission}/>}
    </div>
  );

  const QuoteTab = (
    <div>      
      {(manuallySetPricing && isUnderwriter) && <MinimumPremium
          isModified={isModified}
          limits={pricingValues}
          onBlurHandler={onBlurHandler}
          manuallySetPricing={manuallySetPricing}
          type={submission.type}
      />}
      {(manuallySetPricing && isUnderwriter) && <DeductibleContainer
        onBlurHandler={onBlurHandler}
        isNYDeductible = {submission.isNYDeductible}
        deductibles = {pricingValues.deductibles}
        projectState= {submission.projectAddress.projectState}
        demoCost={submission.demolitionDetailsCost} 
        isDemolitionDetailsInterior={submission.demolitionDetailsInterior}
        contractor={submission.demolitionDetailsGCOwner}
      />}
      {(manuallySetPricing && isUnderwriter) && <ListContainer
              onBlurHandler={onBlurHandler}
              list={subjectivities}
              title="Subjectivities (Prior To Binding)"
              id="subjectivities"
      />}
      {(manuallySetPricing && isUnderwriter) && <ListContainer
              onBlurHandler={onBlurHandler}
              list={subjectivitiesTBD}
              title="Subjectivities (Within 10Days of Binding)"
              id="subjectivitiesDescription"
      />}
      {(manuallySetPricing && isUnderwriter) && <ListContainer
              onBlurHandler={onBlurHandler}
              list={u650Exclusions}
              title="Additional Exclusion U650"
              id="u650Exclusions"
      />}
      {(manuallySetPricing && isUnderwriter) && <GCList
              onBlurHandler={onBlurHandler}
              type={submission.type}
              coverage={coverage}
              pricingValues={pricingValues}
              submission={submission}
              additionalCoverage={additionalCoverage}
              excessLimitAmount={excessLimitAmount}
      />}
      {(manuallySetPricing && isUnderwriter) && <DesignatedGeneralContractor
              onBlurHandler={onBlurHandler}
              type={submission.type}
              coverage={coverage}
              pricingValues={pricingValues}
              submission={submission}
      />}
    </div>
  );

  const SinglePageDisplay = (
    <div>
      {PricingTab}
      {QuoteTab}
    </div>
  );

  const TabbedDisplay = (
    <Tabs defaultActiveKey={1} id="oipricing-tabbed-display" animation={false}>
      <Tab eventKey={1} title="Pricing" tabClassName="tab-header">
        {PricingTab}
      </Tab>
      <Tab eventKey={2} title="Quote" tabClassName="tab-header">
        {QuoteTab}
      </Tab>
    </Tabs>
  );

    return (
        <div>
            {(manuallySetPricing && isUnderwriter) ? TabbedDisplay: SinglePageDisplay}            
        </div>
    );
};

export default connect(
    store => {
        return {
            defaultCoverageOptions: DEFAULT_COVERAGE_OPTIONS,
            defaultCoverageExclusionOptions: COVERAGE_EXCLUSION_OPTIONS,
            defaultAdditionalCoverageOptions: DEFAULT_ADDITIONAL_COVERAGE_OPTIONS,
        };
    },
)(OIPricing);
